import { useFlow, FLOWS } from "hook/register/flow/useFlow";
import React, { useState } from "react";
import RegisterSection from "./register_section";
import RegisterVerify from "./register_verify";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const RegisterForm = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useFlow();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderRegister = () => {
    const isRegister = flow === FLOWS.REGISTER;
    if (!isRegister) return null;
    return <RegisterSection />;
  };

  const renderVerify = () => {
    const isVerify = flow === FLOWS.VERIFY;
    if (!isVerify) return null;
    return <RegisterVerify />;
  };

  // -------------------------- MAIN ----------------------------
  return (
    <React.Fragment>
      {renderRegister()}
      {renderVerify()}
    </React.Fragment>
  );
};
export default RegisterForm;
